import * as Tabs from '@radix-ui/react-tabs';
import { motion, AnimatePresence } from 'framer-motion';
import { Tooltip } from "react-tooltip";
import { useEffect } from 'react';

declare global {
  interface Window {
    vuplex?: {
      postMessage: (message: string) => void;
    };
  }
}

interface ProjectTabsProps {
  children: React.ReactNode;
  activeTab: string;
  isUnityExists: boolean;
  profileProducts: any[];
  onTabChange: (value: string) => void;
}

const ProjectsTableTabs = ({ children, activeTab, onTabChange, profileProducts, isUnityExists }: ProjectTabsProps) => {

  useEffect(() => {
    const handleTooltipClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.tagName === 'A' && target.id === 'view-operational-excellence') {
        e.preventDefault();
        const url = 'https://app.processhub.ai';
   
        if (window.vuplex) {
          const message = JSON.stringify({
            object: "__ApplicationManager__",
            type: "ApplicationManager",
            method: "OpenExternalURL",
            arguments: [JSON.stringify(url)]
          });
          window.vuplex.postMessage(message);
        } else {
          // fallback for normal browser (not inside Unity)
          window.open(url, '_blank', 'noopener,noreferrer');
        }
      }
    };

    // Add click listener to document to catch tooltip content clicks
    document.addEventListener('click', handleTooltipClick);

    return () => {
      document.removeEventListener('click', handleTooltipClick);
    };
  }, []);

  return (
    <div>
      <Tabs.Root value={activeTab} onValueChange={onTabChange}>
        

        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.15 }}
          >
            {children}
          </motion.div>
        </AnimatePresence>
      </Tabs.Root>
      <Tooltip
        id="view-operational-excellence"
        place="top"
        className="bg-[#1A1A1A] z-50 w-[20px] border border-white/[0.08] !opacity-100"
        positionStrategy="fixed"
        style={{
          fontSize: '0.875rem',
          padding: '0.5rem 0.75rem',
          width: "250px"
        }}
        clickable={true}
      />
    </div>
  );
};

export default ProjectsTableTabs;
